import SearchBar from 'components/Search/SearchBar';
import MeetingsToolbar from 'containers/Meetings/MeetingsToolbarContainer';
import _pick from 'lodash/pick';
import React from 'react';
import MaxInactiveDays from 'containers/MaxInactiveDays/MaxInactiveDaysContainer';

interface Props {
  addMeetingModalOpen: () => void;
  deleteMeetings: (arg: Array<string>) => void;
  selectionArray: Array<string>;
  onFilterStringChange: (filterValue: string) => void;
  error?: string;
}

class MeetingsHeader extends React.PureComponent<Props> {
  render() {
    return [
      <SearchBar setFilterString={this.props.onFilterStringChange} key="searchbar" />,
      (
        <div className="toolbar" key="toolbar" data-test="toolbar">
          <MaxInactiveDays />
          <MeetingsToolbar
            {..._pick(this.props, [
              'addMeetingModalOpen',
              'deleteMeetings',
              'selectionArray',
            ])}
          />
        </div>
      )
    ];
  }
}

export default MeetingsHeader;
